import { Fragment } from 'react';
import { useTheme, useUniqueId, ChartState } from '@shopify/polaris-viz-core';
import styles from './SimpleBarSkeleton.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorText } from '../ErrorText/ErrorText.js';

function SimpleBarSkeleton({
  dimensions,
  state,
  errorText
}) {
  const {
    width,
    height
  } = dimensions;
  const {
    grid: {
      color: gridColor
    },
    bar: {
      borderRadius
    }
  } = useTheme();
  const id = useUniqueId('simple-bar-skeleton');

  const BarMarkup = () => /*#__PURE__*/jsx("span", {
    style: {
      display: 'inline-block',
      background: gridColor,
      borderRadius
    }
  });

  return /*#__PURE__*/jsxs("div", {
    className: styles.SimpleBarSkeleton,
    children: [state === ChartState.Loading && /*#__PURE__*/jsx(Fragment, {
      children: new Array(4).fill(0).map((_, index) => /*#__PURE__*/jsxs("div", {
        className: styles.Item,
        children: [/*#__PURE__*/jsx(BarMarkup, {}), /*#__PURE__*/jsx(BarMarkup, {})]
      }, `${id}${index}`))
    }), state === ChartState.Error && /*#__PURE__*/jsx("svg", {
      viewBox: `0 0 ${width} ${height}`,
      children: /*#__PURE__*/jsx(ErrorText, {
        errorText: errorText,
        width: width,
        height: height
      })
    })]
  });
}

export { SimpleBarSkeleton };
